import Anchor from '~components/Anchor/Anchor';
import { useAppSelector } from '~hooks/useRedux';
import greenCheckmark from '~images/common/circle-green-checkmark.svg';
import disabledCheckmark from '~images/common/disabled-checkmark.svg';

type Props = {
    title?: string;
    url: string;
    opensinnewtab: boolean;
    watracking: string;
};

const Step = ({ title = 'title', url, opensinnewtab, watracking }: Props) => {
    const ntmVisited = useAppSelector((state) => state.global.ntmVisited);

    return (
        <li className="flex items-center justify-between w-full md:w-auto">
            <Anchor
                to={url}
                target={opensinnewtab ? '_blank' : ''}
                rel={opensinnewtab ? 'noreferrer' : ''}
                className="text-lg md:text-base flex items-center w-full p-4 font-bold"
                data-wa-link={watracking}
            >
                <img
                    src={ntmVisited.includes(title) ? greenCheckmark : disabledCheckmark}
                    alt=""
                    width="20"
                    height="20"
                    className="mr-2"
                />
                <span className={ntmVisited.includes(title) ? 'text-black' : 'text-primary'}>
                    {title}
                </span>
            </Anchor>
        </li>
    );
};

export default Step;
